import { render, staticRenderFns } from "./sfc-dynamic-tab.vue?vue&type=template&id=33990c0d&scoped=true&lang=pug&"
import script from "./sfc-dynamic-tab.vue?vue&type=script&lang=js&"
export * from "./sfc-dynamic-tab.vue?vue&type=script&lang=js&"
import style0 from "./sfc-dynamic-tab.vue?vue&type=style&index=0&id=33990c0d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33990c0d",
  null
  
)

export default component.exports